"use strict";

var _classCallCheck = require("/tmp/github-runner/alinewines/alinewines/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/tmp/github-runner/alinewines/alinewines/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SynchronizerAction = void 0;

var SynchronizerAction = /*#__PURE__*/function () {
  function SynchronizerAction(controller, type, id, params) {
    var mergeMode = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "extend";

    _classCallCheck(this, SynchronizerAction);

    this.params = params;
    this.id = id;
    this.type = type;
    this.controller = controller.getId();
    this.mergeMode = mergeMode;
  }

  _createClass(SynchronizerAction, [{
    key: "getUuid",
    value: function getUuid() {
      return this.controller + "/" + this.type + "/" + this.id;
    }
  }, {
    key: "merge",
    value: function merge(action) {
      if (!action) {
        return this;
      }

      if (this.mergeMode === "extend") {
        this.params = Object.assign(Object.assign({}, action.params), this.params);
      } else if (this.mergeMode === "concat") {
        this.params = action.params.concat(this.params);
      }

      return this;
    }
  }, {
    key: "export",
    value: function _export() {
      return {
        params: this.params,
        id: this.id,
        type: this.type,
        controller: this.controller,
        uuid: this.getUuid()
      };
    }
  }]);

  return SynchronizerAction;
}();

exports.SynchronizerAction = SynchronizerAction;